import type { FC } from 'react';
import Radio from '@/components/UI/FormElements/Radio/Radio';
import { MAX_PUBLISHED_VIEWS_PER_TABLE, MAX_VIEWS_PER_TABLE } from '@/utils/userTableSettings/UserTableSettings.utils';
import styles from './ViewVisibilityField.module.scss';

interface ViewVisibilityFieldProps {
  published: boolean;
  onChange: (published: boolean) => void;
  disabled?: boolean;
  privateLimitReached?: boolean;
  publishedLimitReached?: boolean;
  testId?: string;
}

const ViewVisibilityField: FC<ViewVisibilityFieldProps> = ({
  published,
  onChange,
  disabled = false,
  privateLimitReached = false,
  publishedLimitReached = false,
  testId = 'view-visibility',
}) => {
  const privateFull = privateLimitReached && published;
  const publishedFull = publishedLimitReached && !published;

  return (
    <fieldset className={styles.fieldset} data-testid={testId}>
      <legend className={styles.legend}>Visibility</legend>
      <Radio
        id={`${testId}--private`}
        name={testId}
        value="private"
        checked={!published}
        label="Private"
        sublabel="Only its creator can see this view"
        disabled={disabled || privateFull}
        onChange={() => onChange(false)}
        dataTestId={`${testId}__private`}
        keyboardFocusable
      />
      <Radio
        id={`${testId}--published`}
        name={testId}
        value="published"
        checked={published}
        label="Published"
        sublabel="Everyone on the team can see this view"
        disabled={disabled || publishedFull}
        onChange={() => onChange(true)}
        dataTestId={`${testId}__published`}
        keyboardFocusable
      />
      {(privateFull || publishedFull) && (
        <small className="db dark-gray pt3" data-testid={`${testId}__limit`}>
          Maximum of {publishedFull ? MAX_PUBLISHED_VIEWS_PER_TABLE : MAX_VIEWS_PER_TABLE}{' '}
          {publishedFull ? 'published' : 'private'} views per table
        </small>
      )}
    </fieldset>
  );
};

export default ViewVisibilityField;
